<h2 class="benefits-title mb-1.5 mt-0">
  {{ 'wl.anz.home_page.benefits.title' | translate }}
</h2>

<p class="benefits-subtitle mb-14 mt-0 lg:mb-12">
  {{ 'wl.anz.home_page.benefits.subtitle' | translate }}
</p>

<div
  class="benefits-container flex flex-col items-stretch justify-center lg:flex-row">
  <div
    class="benefit mb-16 flex flex-col last:mb-0 lg:mb-0"
    [ngClass]="isEverydaySpendEnabled ? 'five-cols' : 'four-cols'"
    *ngFor="let benefit of benefits">
    <img class="benefit-image" [src]="benefit.imageUrl" alt="" />
    <h3 class="heading mb-2 mt-6 lg:ml-4 lg:mt-8">
      {{ benefit.headingKey | translate }}
    </h3>
    <p class="description mb-6 mt-0 lg:ml-4">
      {{ benefit.descriptionKey | translate }}
    </p>
    <rd-shared-button
      class="button mt-auto lg:ml-4"
      [buttonContent]="buttonContent"
      [buttonTheme]="'outline-primary'"
      [redirectURL]="benefit.buttonRedirectUrl"
      [ariaLabel]="benefit.ariaLabel | translate">
      <ng-template #buttonContent>
        <span>{{ benefit.buttonKey | translate }}</span>
      </ng-template>
    </rd-shared-button>
  </div>
</div>
